/**
 * Utility functions for shipping-related operations
 */

import { formatDate } from '@/lib/utils/dateUtils';

/**
 * Generates a tracking URL based on shipping type and tracking ID
 * Supports UPS and FedEx
 */
export const getTrackingLink = (trackingId: string | undefined, shippingType: string | undefined): string => {
  if (!trackingId || !shippingType) return '';
  if (shippingType.startsWith('UPS')) {
    return `https://wwwapps.ups.com/WebTracking?TypeOfInquiryNumber=T&InquiryNumber1=${trackingId}`;
  } else if (shippingType.startsWith('FedEx')) {
    return `https://www.fedex.com/fedextrack/?trknbr=${trackingId}`;
  }
  return '';
};

/**
 * Converts a Date object to a format suitable for backend API
 * Returns undefined if date is null
 */
export const convertDateForBackend = (date: Date | null): Date | undefined => {
  return date ? date : undefined;
};

/**
 * Formats a date for display in the printable form
 */
export const formatDateForPrint = (date: Date | undefined): string => {
  return date ? formatDate(date) : 'N/A';
};

/** Re-export wrapper for compatibility with detail imports. */
export { createShippingSubmitValidation } from '@/lib/validation/submitValidationBuilders';
